import { IAddress, IModel } from 'pbc.types';

export interface IUrlaubsKonto {
  jahr: {
    anspruchUrlaub?: number
    anspruchSonderurlaub?: number
    erlaubt: number
    genommen: number
    verfügbar: number
  }
  übertrag: {
    aus?: number
    bis: Date
    erlaubt: number
    genommen: number
    verfügbar: number
  }
  debug?: object
}

export interface IMinutenKonto {
  erwartet: number;
  gearbeitet: number;
  konto: number;
  rahmen: number;
  drüber?: number;
  drunter?: number;
  sickness?: number;
  holiday?: number;
  base?: {
    days?: number;
    feiertage?: number;
    weekend?: number;
    from?: Date;
    to?: Date;
  };
}

export enum Arbeitstag {
  MONTAG = 1, DIENSTAG = 2, MITTWOCH = 3, DONNERSTAG = 4, FREITAG = 5, SAMSTAG = 6, SONNTAG = 7
}

export interface IArbeitszeitmodell {
  wochenarbeitszeitInStunden: number
  regulaereArbeitstage: Arbeitstag[]
}

export interface IArbeitszeitkonto {
  from: Date;
  to: Date;
  vertragsStunden: number;
  sollArbeitszeitInStunden: number;
  geleisteteArbeitszeitInMinuten: number;
  saldoInMinuten: number;
  saldoUebertragVorJahr: {
    jahr: number;
    uebertragMinutenAusVorJahr: number;
  }
  debug?: any;
}

export interface IUrlaubsanspruch {
  seqNumber: number;
  start: Date;
  end?: Date | null;
  urlaubsanspruch: number;
}

export interface IMitarbeiter extends IModel {
  id?: string;
  email: string;
  anzeigename: string;
  bild?: string;
  addresse?: IAddress;
  vorname?: string;
  nachname?: string;
  telefon?: string;
  standort: string;
  rollen: string[];
  stundenlohn?: number;
  stundenProTag?: number;
  partner?: string;
  minuten?: IMinutenKonto;
  urlaub?: IUrlaubsKonto;
  no_stundenkontomails?: boolean;
  urlaubstage?: number; // TODO remove from db
  urlaubsansprueche?: IUrlaubsanspruch[];
  urlaubsmonat?: number; // TODO remove from db
  urlaubsübertrag2023?: number; // TODO remove from db
  stundenübertrag2023?: number; // TODO remove from db
  arbeitszeitmodell?: IArbeitszeitmodell;
  urlaubsuebertrag?: Record<number, number>;
  sonderurlaub?: Record<number, number>;
  arbeitszeitUebertrag?: Record<number, number>;
  einstiegsdatum?: Date;
  ausstiegsdatum?: Date;
  inaktiv?: boolean;
  isAdmin: boolean;
  groups: string[];
  tourenplanung?: boolean;
  colorIndex?: number;
  color?: string;
  initialen?: string;
}
